import classNames from "classnames";
import { BuilderComponentProps } from "../BuilderInterface";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";
import "./style.scss";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { NodeStates } from "../../build/types";

const BuilderEmbedSection = ({ node, children, builderProps, actionCallbacks, disabled }: BuilderComponentProps) => {
    const { id, attr, stateManager } = node;
    const embedSectionClass = classNames("builder-embed-section", {
        [`${attr?.className}`]: !!attr?.className
    });
    const { setElement, states } = useInteractionStates<HTMLDivElement>();

    if (builderProps) {
        const { selectedMenu, nodeState, selectCallback, outlineCallback, onDragStart, onDragEnd } = builderProps;

        return (
            <div
                className={embedSectionClass}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                onDragStart={e => onDragStart?.(e, id)}
                draggable={onDragStart ? "true" : "false"}
                onDragEnd={onDragEnd}
                {...actionCallbacks}
                style={getCompoundStyle({
                    node,
                    stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
                })}
                id={id}
            >
                {children}
                {selectedMenu}
            </div>
        );
    } else {
        const embedStyles = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node }),
            stateManager,
            paths: ["attr_style"],
            ...(disabled ? { extraStates: [NodeStates.DISABLED] } : {})
        });

        return (
            <div ref={setElement} style={embedStyles} className={embedSectionClass} {...actionCallbacks} id={id}>
                {children}
            </div>
        );
    }
};

export default BuilderEmbedSection;
